import React, { useMemo, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Star01,
  Star02,
  Star03,
  Star04,
  Star05,
  Star06,
  Star07,
  Star08,
  Star09,
  Star10,
} from '../../../assets/stars';
import { Context } from '../../../context/AppContext';
import smoothScroll from '../../../utils/smoothScroll';
import './styles.css';

const ReviewStars = ({
  rating,
  count,
  width,
  average,
  countText,
  className,
  addLink,
}) => {
  const {
    media: { desktop, tablet },
  } = useContext(Context);
  const starArrayFull = useMemo(() => [1, 2, 3, 4, 5], []);

  const { ratings, decimal } = useMemo(() => {
    const hasDecimal = rating && rating.toString().length > 1;
    const decimalNumber = hasDecimal
      ? Number(rating.toString().slice(2, 3))
      : null;
    const roundedRating = decimalNumber
      ? Math.floor(rating) + 1
      : Math.floor(rating);
    return {
      ratings: starArrayFull.slice(0, roundedRating),
      decimal: decimalNumber,
    };
  }, [rating, starArrayFull]);

  return (
    <div
      className={classNames('ReviewStars__root', {
        [className]: className,
      })}
    >
      <div className="ReviewStars__stars">
        {starArrayFull.map((num, index) => {
          const fullStar = ratings.length >= index + 1;
          if (decimal && ratings.length === index + 1) {
            return (
              <div key={num} className="ReviewStars__starWrap">
                <Star10
                  fill="#e9e9e9"
                  width={width}
                  className="ReviewStars__emptyStar"
                />
                {decimal === 1 && (
                  <Star01
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 2 && (
                  <Star02
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 3 && (
                  <Star03
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 4 && (
                  <Star04
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 5 && (
                  <Star05
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 6 && (
                  <Star06
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 7 && (
                  <Star07
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 8 && (
                  <Star08
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
                {decimal === 9 && (
                  <Star09
                    fill="#ffc413"
                    width={width}
                    className="ReviewStars__halfStar"
                  />
                )}
              </div>
            );
          }
          return (
            <div key={num}>
              <Star10 fill={fullStar ? '#ffc413' : '#e9e9e9'} width={width} />
            </div>
          );
        })}
      </div>
      {!!(average || count > -1 || countText) && (
        <div className="ReviewStars__meta">
          {average ? <div className="ReviewStars__average">{average}</div> : ''}

          {countText ? (
            <div className="ReviewStars__count">{countText}</div>
          ) : (
            <Fragment>
              {count === 0 && (
                <div className="ReviewStars__count">No reviews yet</div>
              )}
              {count > 0 && (
                <div className="ReviewStars__count">
                  {addLink ? (
                    <button
                      type="button"
                      onClick={() => {
                        smoothScroll(
                          document.querySelector('.Profile__Reviews__root'),
                          desktop || tablet ? 55 : 84
                        );
                      }}
                    >
                      {' '}
                      {count} Review{count > 1 ? 's' : ''}
                    </button>
                  ) : (
                    <Fragment>
                      {' '}
                      {count} Review{count > 1 ? 's' : ''}
                    </Fragment>
                  )}
                </div>
              )}
            </Fragment>
          )}
        </div>
      )}
    </div>
  );
};

ReviewStars.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number,
  countText: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.number,
  average: PropTypes.number,
};

ReviewStars.defaultProps = {
  rating: null,
  count: null,
  average: null,
  countText: null,
  width: 15,
};
export default ReviewStars;
